import { Children, isValidElement, type ReactNode } from "react";

import { FixedPanelTab, type FixedPanelTabProps } from "../components/FixedPanelTab.tsx";

// Extract tab data from FixedPanelTab children
export const extractTabsFromChildren = (children: ReactNode) => {
  const tabs: FixedPanelTabProps[] = [];

  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === FixedPanelTab) {
      const props = child.props as FixedPanelTabProps;
      tabs.push({
        id: props.id,
        title: props.title,
        icon: props.icon,
        position: props.position ?? 999,
        children: props.children,
      });
    }
  });

  // Sort by position
  return tabs.sort((a, b) => a.position - b.position);
};
